import React from "react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import * as actions from "../../../actions";

class YearComponent extends React.Component {
  render() {
    var scenarii = this.props.scenarii;
    if (this.props.isGest) {
    }
    const isSameuserType =
      this.props.me.userType == "ADMIN" ||
      this.props.me.userType == "ADMIN_REGION" ||
      this.props.me.userType == "MANAGER_LOCAL_AUTHORITY";
  const showButton  = new Date().getFullYear()>this.props.year && this.props.isGest 
    return (
      <div className="scenario-year-component">
        {this.props.couldCreate && !this.props.consulted ? (
          this.props.previousValidatedScenarioExists &&
          this.props.me.userType == "ADMIN" ? (
            <button onClick={this.props.onCreate}>
              + Depuis le modèle validé de l'année précédente
            </button>
          ) : (
            <button onClick={this.props.onCreate}>
              + Ajouter un premier scenario
            </button>
          )
        ) : this.props.scenarii.length > 0 ? (
          <div className="scenarii-list">
            <div className="scenario-item">
              {isSameuserType && (
                <div className="scenario-validator scn-title">Validé</div>
              )}
              <div className="scenario-identifier scn-title">N°</div>
              <div className="scenario-description scn-title">Description</div>
              <div className="scenario-actions scn-title"></div>
            </div>

            {this.props.scenarii.map((scenario) => (
              <div key={"scenario-" + scenario.id} className="scenario-item">
                {isSameuserType && (
                  <div className="scenario-validator">
                    <input
                      type="radio"
                      onClick={this._handleValid.bind(this, scenario)}
                      checked={scenario.validated ? "checked" : null}
                    />
                  </div>
                )}
                <div className="scenario-identifier">
                  {
                scenario.identifier
                  }
                </div>
                <div className="scenario-description">
                  {
                    scenario.description
                  }
                 
                </div>
                {scenario.arbitrage && scenario.validated && !showButton &&(
                  <button
                    className="button"
                    onClick={() => this._handleSenarios(scenario)}
                    style={{ backgroundColor: "#363437", color: "white" }}
                  > 
                    Arbitrage
                  </button>
                )}
          
                <div className="scenario-actions">
                  {scenario.validated &&
                  this.props.year === (new Date().getFullYear() - 1)  ? (
                    <button
                      onClick={this._handleUpdateRetro.bind(this, scenario)}
                      style={{ width: 150, height:40, borderRadius: 10, fontSize:13 }}
                      title="Mettre à jour la retrospective"
                    >
                      <i className="fa fa-check" /> MAJ Retrospective
                    </button>
                  ) : null}
                   {!this.props.isGest && !this.props.consulted ? (
                    <button
                      onClick={this._handleEdit.bind(this, scenario)}
                      style={{ width:40, height:40, borderRadius: 20 }}
                      title="Modifier les informations du scénario"
                    >
                      <i className="fa fa-edit fa-2x" />
                    </button>
                  ) : null}
                   {!scenario.validated ? (
                    !this.props.isGest && !this.props.consulted ? (
                      <button
                        onClick={this._handleDelete.bind(this, scenario)}
                        style={{ width:40, height:40, borderRadius: 20 }}
                        title="Supprimer le scénario"
                      >
                        <i className="fa fa-trash fa-2x" />
                      </button>
                    ) : null
                  ) 
                  : (
                    !showButton &&
                   ( <button
                      onClick={this._handleManage.bind(this, scenario)}
                      style={{ width:40, height:40, borderRadius: 20 }}
                      title="Accéder à la répartition par gestionnaire"
                    >
                      <i className="fa fa-table fa-2x" />
                    </button>)
                    
                  )
                  }
                   {!this.props.isGest ? (
                    <button
                      onClick={this._handleSee.bind(this, scenario)}
                      style={{ width:40, height:40, borderRadius: 20 }}
                      title="Compléter le scénario"
                    >
                      <i className="fa fa-cogs fa-2x" />
                    </button>
                  ) : null}
                  {!this.props.isGest && !this.props.consulted ? (
                    <button
                      onClick={this._handleDuplicate.bind(this, scenario)}
                      style={{ width:40, height:40, borderRadius: 20 }}
                      title="Dupliquer le scénario"
                    >
                      <i className="fa fa-clone fa-2x" />
                    </button>
                  ) : null}                
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="no-scenario">
            Aucun scénario pour l'année {this.props.year}
          </div>
        )}
      </div>
    );
  }

  _handleUpdateRetro(scenario) {
    this.props.onCustomAction({
      action: "update_retro",
      actionData: { scenario },
    });
  }

  _handleSenarios(scenario) {
    this.props.onCustomAction({
      action: "equilibrage_scenario",
      actionData: { scenario },
    });
  }

  _handleNewSenarios(scenario) {
    this.props.onCustomAction({
      action: "new_scenario",
      actionData: { scenario },
    });
  }

  _handleDuplicate(scenario) {
    this.props.onCustomAction({
      action: "duplicate_scenario",
      actionData: { scenario },
    });
  }

  _handleDelete(scenario) {
    this.props.onCustomAction({
      action: "delete_scenario",
      actionData: { scenario },
    });
  }

  _handleManage(scenario) {
    this.props.onCustomAction({
      action: "manage_scenario",
      actionData: { scenario },
    });
  }

  _handleEdit(scenario) {
    this.props.onCustomAction({
      action: "edit_scenario",
      actionData: { scenario },
    });
  }

  _handleSee(scenario) {
    this.props.onCustomAction({
      action: "see_scenario",
      actionData: { scenario },
    });
  }

  _handleValid(scenario) {
    if (
      !scenario.validated ||
      this.props.me.roles.indexOf("ROLE_SUPER_ADMIN") !== -1
    ) {
      this.props.onCustomAction({
        action: "valid_scenario",
        actionData: { scenario },
      });
    }
  }
}

const mapStateToProps = (state) => ({
  currentLocalAuthority: state.currentLocalAuthority,
  me: state.currentUser,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(YearComponent);


// WEBPACK FOOTER //
// ./src/component/scenarii/manager/year-component.js